import React, { useEffect, useState } from 'react';
import { AlertTriangle, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PROFANITY_AUDIO_WARNING = 'Profanity detected. This recording contains language that some listeners may find offensive.';

// The recording itself is always the original; when profanity was detected the
// listener must confirm before the player appears.
export default function GatedAudio({ src, warn, testId }) {
  const [allowed, setAllowed] = useState(!warn);
  useEffect(() => { setAllowed(!warn); }, [warn, src]);
  if (!allowed) {
    return (
      <div role="alert" className="max-w-md rounded-xl border border-[#FCD34D] bg-[#FFFBEB] px-4 py-3" data-testid={`${testId}-warning`}>
        <p className="text-sm text-[#92400E] flex items-start gap-2">
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
          <span data-testid={`${testId}-warning-text`}>{PROFANITY_AUDIO_WARNING}</span>
        </p>
        <Button type="button" size="sm" variant="outline" onClick={() => setAllowed(true)}
          className="mt-3 border-[#F3C969] text-[#92400E] hover:bg-[#FEF3C7]" data-testid={`${testId}-play-anyway`}>
          <Play className="w-3.5 h-3.5 mr-1.5" /> Play recording
        </Button>
      </div>
    );
  }
  return <audio controls autoPlay={!!warn} preload="metadata" src={src} className="w-full max-w-md" data-testid={testId} />;
}
